import { useEffect, useState } from 'react';
import { AGENCY_TZ } from '../api';
import { PageHeader } from './Ui';

// Words that mark a login named after a business, a role or a test account rather than a person.
const NOT_A_PERSON = new Set(('llc inc co corp ltd portal qa test demo admin administrator owner office team staff desk support info sales service services billing front account accounts '
  + 'marketing media agency company group partners associates solutions systems technologies tech consulting management properties property realty holdings enterprises industries '
  + 'junk king removal hauling painting maid maids appliance cleaning cleaners roofing plumbing hvac lawn pest electric electrical heating cooling air water pool landscaping construction builders contracting '
  + 'law legal clinic dental salon spa auto repair home store shop restaurant cafe grill pizza market fitness gym wellness health care medical pharmacy veterinary animal pet school academy church center centre club studio').split(' '));
/** The first name when the account name reads like a person's (two to four plain words, none a business word, no digits, no all-caps word); otherwise nothing. */
export function firstNameOf(name?: string): string {
  const words = (name || '').trim().split(/\s+/).filter(Boolean);
  if (words.length < 2 || words.length > 4) return '';
  if (!words.every((w) => /^[A-Za-z'\u2019.-]+$/.test(w))) return '';
  if (words.some((w) => NOT_A_PERSON.has(w.replace(/[.]/g, '').toLowerCase()) || (w.length > 1 && w === w.toUpperCase()))) return '';
  return /^[A-Z][A-Za-z'\u2019-]+$/.test(words[0]) ? words[0] : '';
}

/** Overview's header: the same shape and size as every portal page's (a title and one line), with the greeting as its title. */
export default function PortalWelcome({ name, company }: { name?: string; company: string }) {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const timer = window.setInterval(() => setNow(new Date()), 60_000);
    return () => window.clearInterval(timer);
  }, []);
  const hour = Number(new Intl.DateTimeFormat('en-US', { hour: 'numeric', hourCycle: 'h23', timeZone: AGENCY_TZ }).format(now));
  const greeting = hour < 12 ? 'Good morning' : hour < 18 ? 'Good afternoon' : 'Good evening';
  const firstName = firstNameOf(name);
  return <PageHeader title={`${greeting}${firstName ? `, ${firstName}` : ''}.`} description={`Your requests and results for ${company}.`} />;
}
